import type { IPlace } from './countries'

// The zone a location in a place should default to, derived from the IANA country and subdivision
// tables that date-holidays ships. Values are ids from ./timezone, because a zone the picker does
// not offer cannot be selected back once it is stored - where a country's own zone is missing
// (India's Asia/Kolkata, which we carry as the legacy Asia/Calcutta) the picker entry that keeps
// the same time all year stands in for it.
const COUNTRY_TIMEZONES: Record<string, string> = {
  'AD': 'Europe/Andorra',
  'AE': 'Asia/Dubai',
  'AF': 'Asia/Kabul',
  'AG': 'America/Port_of_Spain',
  'AI': 'America/Port_of_Spain',
  'AL': 'Europe/Tirane',
  'AM': 'Asia/Yerevan',
  'AO': 'Africa/Lagos',
  'AQ': 'Antarctica/Casey',
  'AR': 'America/Argentina/Buenos_Aires',
  'AS': 'Pacific/Pago_Pago',
  'AT': 'Europe/Vienna',
  'AU': 'Australia/Sydney',
  'AW': 'America/Curacao',
  'AX': 'Europe/Helsinki',
  'AZ': 'Asia/Baku',
  'BA': 'Europe/Belgrade',
  'BB': 'America/Barbados',
  'BD': 'Asia/Dhaka',
  'BE': 'Europe/Brussels',
  'BF': 'Africa/Abidjan',
  'BG': 'Europe/Sofia',
  'BH': 'Asia/Qatar',
  'BI': 'Africa/Maputo',
  'BJ': 'Africa/Lagos',
  'BL': 'America/Caracas',
  'BM': 'Atlantic/Bermuda',
  'BN': 'Asia/Brunei',
  'BO': 'America/La_Paz',
  'BQ': 'America/Curacao',
  'BR': 'America/Sao_Paulo',
  'BS': 'America/Nassau',
  'BT': 'Asia/Thimphu',
  'BW': 'Africa/Maputo',
  'BY': 'Europe/Minsk',
  'BZ': 'America/Belize',
  'CA': 'America/Toronto',
  'CC': 'Indian/Cocos',
  'CD': 'Africa/Maputo',
  'CF': 'Africa/Lagos',
  'CG': 'Africa/Lagos',
  'CH': 'Europe/Zurich',
  'CI': 'Africa/Abidjan',
  'CK': 'Pacific/Rarotonga',
  'CL': 'America/Santiago',
  'CM': 'Africa/Lagos',
  'CN': 'Asia/Shanghai',
  'CO': 'America/Bogota',
  'CR': 'America/Costa_Rica',
  'CU': 'America/Havana',
  'CV': 'Atlantic/Cape_Verde',
  'CW': 'America/Curacao',
  'CX': 'Indian/Christmas',
  'CY': 'Asia/Nicosia',
  'CZ': 'Europe/Prague',
  'DE': 'Europe/Berlin',
  'DJ': 'Africa/Nairobi',
  'DK': 'Europe/Copenhagen',
  'DM': 'America/Port_of_Spain',
  'DO': 'America/Santo_Domingo',
  'DZ': 'Africa/Algiers',
  'EC': 'America/Guayaquil',
  'EE': 'Europe/Tallinn',
  'EG': 'Africa/Cairo',
  'EH': 'Africa/El_Aaiun',
  'ER': 'Africa/Nairobi',
  'ES': 'Europe/Madrid',
  'ET': 'Africa/Nairobi',
  'FI': 'Europe/Helsinki',
  'FJ': 'Pacific/Fiji',
  'FK': 'Atlantic/Stanley',
  'FM': 'Pacific/Pohnpei',
  'FO': 'Atlantic/Faroe',
  'FR': 'Europe/Paris',
  'GA': 'Africa/Lagos',
  'GB': 'Europe/London',
  'GD': 'America/Port_of_Spain',
  'GE': 'Asia/Tbilisi',
  'GF': 'America/Cayenne',
  'GG': 'Europe/Dublin',
  'GH': 'Africa/Accra',
  'GI': 'Europe/Gibraltar',
  'GL': 'America/Godthab',
  'GM': 'Africa/Abidjan',
  'GN': 'Africa/Abidjan',
  'GP': 'America/Caracas',
  'GQ': 'Africa/Lagos',
  'GR': 'Europe/Athens',
  'GS': 'Atlantic/South_Georgia',
  'GT': 'America/Guatemala',
  'GU': 'Pacific/Guam',
  'GW': 'Africa/Bissau',
  'GY': 'America/Guyana',
  'HK': 'Asia/Hong_Kong',
  'HN': 'America/Tegucigalpa',
  'HR': 'Europe/Belgrade',
  'HT': 'America/Port-au-Prince',
  'HU': 'Europe/Budapest',
  'IC': 'Atlantic/Canary',
  'ID': 'Asia/Jakarta',
  'IE': 'Europe/Dublin',
  'IL': 'Asia/Jerusalem',
  'IM': 'Europe/Dublin',
  'IN': 'Asia/Calcutta',
  'IO': 'Indian/Chagos',
  'IQ': 'Asia/Baghdad',
  'IR': 'Asia/Tehran',
  'IS': 'Atlantic/Reykjavik',
  'IT': 'Europe/Rome',
  'JE': 'Europe/Dublin',
  'JM': 'America/Jamaica',
  'JO': 'Asia/Amman',
  'JP': 'Asia/Tokyo',
  'KE': 'Africa/Nairobi',
  'KG': 'Asia/Bishkek',
  'KH': 'Asia/Bangkok',
  'KI': 'Pacific/Tarawa',
  'KM': 'Africa/Nairobi',
  'KN': 'America/Port_of_Spain',
  'KP': 'Asia/Pyongyang',
  'KR': 'Asia/Seoul',
  'KW': 'Asia/Riyadh',
  'KY': 'America/Panama',
  'KZ': 'Asia/Almaty',
  'LA': 'Asia/Bangkok',
  'LB': 'Asia/Beirut',
  'LC': 'America/Port_of_Spain',
  'LI': 'Europe/Zurich',
  'LK': 'Asia/Colombo',
  'LR': 'Africa/Monrovia',
  'LS': 'Africa/Johannesburg',
  'LT': 'Europe/Vilnius',
  'LU': 'Europe/Luxembourg',
  'LV': 'Europe/Riga',
  'LY': 'Africa/Tripoli',
  'MA': 'Africa/Casablanca',
  'MC': 'Europe/Monaco',
  'MD': 'Europe/Chisinau',
  'ME': 'Europe/Belgrade',
  'MF': 'America/Caracas',
  'MG': 'Africa/Nairobi',
  'MH': 'Pacific/Majuro',
  'MK': 'Europe/Belgrade',
  'ML': 'Africa/Abidjan',
  'MM': 'Asia/Rangoon',
  'MN': 'Asia/Ulaanbaatar',
  'MO': 'Asia/Macau',
  'MP': 'Pacific/Guam',
  'MQ': 'America/Martinique',
  'MR': 'Africa/Abidjan',
  'MS': 'America/Port_of_Spain',
  'MT': 'Europe/Malta',
  'MU': 'Indian/Mauritius',
  'MV': 'Indian/Maldives',
  'MW': 'Africa/Maputo',
  'MX': 'America/Mexico_City',
  'MY': 'Asia/Kuala_Lumpur',
  'MZ': 'Africa/Maputo',
  'NA': 'Africa/Windhoek',
  'NC': 'Pacific/Noumea',
  'NE': 'Africa/Lagos',
  'NF': 'Pacific/Norfolk',
  'NG': 'Africa/Lagos',
  'NI': 'America/Managua',
  'NL': 'Europe/Amsterdam',
  'NO': 'Europe/Oslo',
  'NP': 'Asia/Katmandu',
  'NR': 'Pacific/Nauru',
  'NU': 'Pacific/Niue',
  'NZ': 'Pacific/Auckland',
  'OM': 'Asia/Dubai',
  'PA': 'America/Panama',
  'PE': 'America/Lima',
  'PF': 'Pacific/Tahiti',
  'PG': 'Pacific/Port_Moresby',
  'PH': 'Asia/Manila',
  'PK': 'Asia/Karachi',
  'PL': 'Europe/Warsaw',
  'PM': 'America/Miquelon',
  'PN': 'Pacific/Pitcairn',
  'PR': 'America/Puerto_Rico',
  'PS': 'Asia/Gaza',
  'PT': 'Europe/Lisbon',
  'PW': 'Pacific/Palau',
  'PY': 'America/Asuncion',
  'QA': 'Asia/Qatar',
  'RE': 'Indian/Reunion',
  'RO': 'Europe/Bucharest',
  'RS': 'Europe/Belgrade',
  'RU': 'Europe/Moscow',
  'RW': 'Africa/Maputo',
  'SA': 'Asia/Riyadh',
  'SB': 'Pacific/Guadalcanal',
  'SC': 'Indian/Mahe',
  'SD': 'Africa/Khartoum',
  'SE': 'Europe/Stockholm',
  'SG': 'Asia/Singapore',
  'SH': 'Africa/Abidjan',
  'SI': 'Europe/Belgrade',
  'SJ': 'Europe/Oslo',
  'SK': 'Europe/Amsterdam',
  'SL': 'Africa/Abidjan',
  'SM': 'Europe/Rome',
  'SN': 'Africa/Abidjan',
  'SO': 'Africa/Nairobi',
  'SR': 'America/Paramaribo',
  'SS': 'Africa/Maputo',
  'ST': 'Africa/Abidjan',
  'SV': 'America/El_Salvador',
  'SX': 'America/Curacao',
  'SY': 'Asia/Damascus',
  'SZ': 'Africa/Johannesburg',
  'TC': 'America/Grand_Turk',
  'TD': 'Africa/Ndjamena',
  'TF': 'Indian/Kerguelen',
  'TG': 'Africa/Abidjan',
  'TH': 'Asia/Bangkok',
  'TJ': 'Asia/Dushanbe',
  'TK': 'Pacific/Fakaofo',
  'TL': 'Asia/Dili',
  'TM': 'Asia/Ashgabat',
  'TN': 'Africa/Tunis',
  'TO': 'Pacific/Tongatapu',
  'TP': 'Asia/Dili',
  'TR': 'Europe/Istanbul',
  'TT': 'America/Port_of_Spain',
  'TV': 'Pacific/Funafuti',
  'TW': 'Asia/Taipei',
  'TZ': 'Africa/Nairobi',
  'UA': 'Europe/Kiev',
  'UG': 'Africa/Nairobi',
  'UM': 'Pacific/Wake',
  'US': 'America/New_York',
  'UY': 'America/Montevideo',
  'UZ': 'Asia/Tashkent',
  'VA': 'Europe/Rome',
  'VC': 'America/Port_of_Spain',
  'VE': 'America/Caracas',
  'VG': 'America/Port_of_Spain',
  'VI': 'America/Port_of_Spain',
  'VN': 'Asia/Bangkok',
  'VU': 'Pacific/Efate',
  'WF': 'Pacific/Wallis',
  'WS': 'Pacific/Apia',
  'YE': 'Asia/Riyadh',
  'YT': 'Africa/Nairobi',
  'ZA': 'Africa/Johannesburg',
  'ZM': 'Africa/Maputo',
  'ZW': 'Africa/Maputo',
}

// Only the regions whose zone differs from their country's - everything else falls through below.
// A country absent here is single-zone, not overlooked: all 16 German states keep Europe/Berlin.
//
// CA-QC and CA-PE are set by hand. The tz database lists every zone that touches a region rather
// than its principal one, which puts Quebec under America/Blanc-Sablon - a village on Atlantic time
// - and Prince Edward Island under Toronto when it is Atlantic like its neighbours.
const SUBDIVISION_TIMEZONES: Record<string, string> = {
  'AU-NT': 'Australia/Darwin',
  'AU-QLD': 'Australia/Brisbane',
  'AU-SA': 'Australia/Adelaide',
  'AU-TAS': 'Australia/Hobart',
  'AU-WA': 'Australia/Perth',
  'CA-AB': 'America/Edmonton',
  'CA-BC': 'America/Vancouver',
  'CA-MB': 'America/Winnipeg',
  'CA-NB': 'America/Halifax',
  'CA-NL': 'America/St_Johns',
  'CA-NS': 'America/Halifax',
  'CA-NT': 'America/Yellowknife',
  'CA-NU': 'America/Iqaluit',
  'CA-PE': 'America/Halifax',
  'CA-SK': 'America/Regina',
  'CA-YT': 'America/Whitehorse',
  'ES-CN': 'Atlantic/Canary',
  'US-AK': 'America/Anchorage',
  'US-AL': 'America/Chicago',
  'US-AR': 'America/Chicago',
  'US-AZ': 'America/Phoenix',
  'US-CA': 'America/Los_Angeles',
  'US-CO': 'America/Denver',
  'US-HI': 'Pacific/Honolulu',
  'US-IA': 'America/Chicago',
  'US-ID': 'America/Denver',
  'US-IL': 'America/Chicago',
  'US-KS': 'America/Chicago',
  'US-LA': 'America/Chicago',
  'US-MN': 'America/Chicago',
  'US-MO': 'America/Chicago',
  'US-MS': 'America/Chicago',
  'US-MT': 'America/Denver',
  'US-ND': 'America/Chicago',
  'US-NE': 'America/Chicago',
  'US-NM': 'America/Denver',
  'US-NV': 'America/Los_Angeles',
  'US-OK': 'America/Chicago',
  'US-OR': 'America/Los_Angeles',
  'US-SD': 'America/Chicago',
  'US-TN': 'America/Chicago',
  'US-TX': 'America/Chicago',
  'US-UT': 'America/Denver',
  'US-WA': 'America/Los_Angeles',
  'US-WI': 'America/Chicago',
  'US-WY': 'America/Denver',
}

/**
 * The timezone a location in this place should default to, or undefined when the country is
 * unknown to us - the caller then keeps whatever it already had.
 */
export const timezoneForPlace = (place: IPlace): string | undefined => SUBDIVISION_TIMEZONES[place.subdivisionCode ?? ''] ?? COUNTRY_TIMEZONES[place.countryCode]
